import { useContext } from 'react'

import {
  type CommandPaletteContextValue,
  CommandPaletteContext
} from './context'

export function useCommandPalette(): CommandPaletteContextValue {
  const ctx = useContext(CommandPaletteContext)
  if (!ctx) {
    throw new Error(
      'useCommandPalette must be called inside <CommandPaletteProvider>'
    )
  }
  return ctx
}
